<script>
import { ref } from "vue";
import InputField from "../InputField.vue";
import { mapActions } from "vuex";
import { storeName } from "@/global/variable";

export default {
  name: "TpslModifyModal",
  components: { InputField },
  props: {
    tradeConfigId: Number,
    tradeItemId: Number,
    tpslType: String,
    buyConfig: Object,
  },
  setup() {
    let percent = ref(0);
    return {
      percent,
    };
  },
  data() {
    return {
      modalType: this.tpslType === "tp" ? "수익실현" : "강제매도",
    };
  },
  methods: {
    ...mapActions(storeName.buyConfig, ["AC_MODIFY_TPSL"]),

    async tpslSave() {
      console.log(this.percent);
      const tradeConfigId = this.buyConfig.config.tradeId;
      const tradeItemId =
        this.tpslType === "tp"
          ? this.buyConfig.profit.tradeItemId
          : this.buyConfig.force.tradeItemId;

      if (Number(this.percent) <= 0) {
        alert("수익실현 퍼센트는 0 이상 입력해주시기 바랍니다.");
        return;
      }
      if (!tradeConfigId || !tradeItemId) {
        alert("올바르지 않은 접근입니다. 새로고침 후 이용해주시기 바랍니다.");
        return;
      }

      const patchBody = {
        percent: this.percent,
      };

      console.log("ci", tradeConfigId);
      console.log("cti", tradeItemId);
      console.log(patchBody);

      await this.AC_MODIFY_TPSL({
        tradeConfigId: tradeConfigId,
        tradeItemId: tradeItemId,
        body: patchBody,
      });

      this.$emit("modal-close");
    },
  },
};
</script>
<template>
  <div class="common-modal-wrap">
    <div class="pc-modal-content">
      <div class="pc-modal-header">
        <h2 class="text-lg font-bold">{{ modalType }} (%) 수정</h2>
        <button class="text-gray-500" @click="$emit('modal-close')">
          닫기
        </button>
      </div>
      <div class="p-4 text-left">
        <!-- <p>{{ buyConfig.config.tradeId }}</p>
        <p>
          {{
            this.tpslType === "tp"
              ? buyConfig.profit.tradeItemId
              : buyConfig.force.tradeItemId
          }}
        </p> -->
        <div class="bg-orange-50 px-4 py-2">
          <ul>
            <li>
              <label>초기 포지션 진입 코인 가격</label>
              <p class="text-right font-semibold">
                {{ buyConfig.config.initEntryPrice }} <small>USDT</small>
              </p>
            </li>
            <li>
              <label>기존 매도설정(%) 값</label>
              <p class="text-right font-semibold">
                {{ buyConfig.config.takeProfitPercent }} <small>%</small>
              </p>
            </li>
          </ul>
        </div>

        <ul class="py-2">
          <li>
            <label>변경할 값</label>
            <div>
              <InputField
                :suffix="'%'"
                :tooltipDisabled="true"
                v-model="percent"
              />
            </div>
          </li>
        </ul>
        <div class="pt-2">
          <button
            type="button"
            class="bg-blue-500 text-white w-full py-2 rounded"
            @click="tpslSave"
          >
            저장
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
